<template>
  <!-- Price Section start-->
  <div class="taption-privacy" name="termly-embed" data-id="2275745e-4237-48ce-83a9-917dfd6e7b3a" data-type="iframe"></div>

</template>

<script>

export default {
    name: 'PrivacyPage',
    created(){
        const id = 'termly-jssdk';
        var js, tjs = document.getElementsByTagName('script')[0];
        if (document.getElementById(id)) return;
        js = document.createElement('script'); 
        js.id = id;
        js.src = "https://app.termly.io/embed-policy.min.js";
        
        tjs.parentNode.insertBefore(js, tjs);
    }
}
</script>

<style scoped>
.taption-privacy{
    padding:0px 100px;
}
</style>

